import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { switchMap } from 'rxjs/operators';
import { SaguiClienteService } from 'src/app/saguicliente/shared/saguicliente.service';

@Injectable()
export class TemplateService {

    getEmpresa(): Observable<HttpResponse<any>> {
        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/template/visualizatodasempresas', { observe: 'response' })
    }

    getContratoTemplates(filtro): Observable<HttpResponse<any>> {

        const params = filtro;

        return this.http.get( 
            environment.webApiSaguiControlUrl + '/api/template/visualizatodasporfiltro/', { observe: 'response', params })
    }

    ListaTiposTemplates(): Observable<HttpResponse<any>>{
        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/Template/TipoTemplates', { observe: 'response' })
    }



      PostContratoTemplatesTags(parametros: any): Observable<HttpResponse<any>> {
            
            const params = {
                empresasIds: parametros.empresasIds,
                tipoTemplate: parametros.tipoTemplate
            };
    
            return this.saguiClienteService.getUrlPorSegmento().pipe(
                switchMap(segmento => {
                    if (segmento == 2) {
                        return this.http.get(environment.webApiSaguiEduUrl + '/api/template/retornatags/', {
                            observe: 'response',
                            params
                        });
                    }
                    else{
                        return this.http.get(
                            environment.webApiSaguiControlUrl + '/api/template/retornatags/', { observe: 'response', params })
                    }
                })
              );
    
                
        }

    GetTemplateTabelasDinamicas(parametros: any): Observable<HttpResponse<any>> {
        
        const params = {
            tipoTemplate: parametros.tipoTemplate
        }
        
        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/template/retornatabelasdinamicas/', { observe: 'response', params })
    }

    getContratoTemplate(itemId: any): Observable<HttpResponse<any>> {
        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/template/visualiza/' + itemId, { observe: 'response' })
    }

    postContratoTemplate(item: any): Observable<HttpResponse<any>> {
        return this.http.post(
            environment.webApiSaguiControlUrl + '/api/template/inclui/', item, { observe: 'response' })
    };

    putContratoTemplate(item: any, itemId: any): Observable<HttpResponse<any>> {
        return this.http.put(
            environment.webApiSaguiControlUrl + '/api/template/atualiza/' + itemId, item, { observe: 'response' })
    };

    deleteContratoTemplate(itemId: any): Observable<HttpResponse<any>> {
        return this.http.delete(
            environment.webApiSaguiControlUrl + '/api/template/exclui/' + itemId, { observe: 'response' })
    }

    uploadImagemTemplate(arquivo: File): Observable<HttpResponse<any>> {
        const formData = new FormData();
        formData.append('arquivo', arquivo);

        return this.http.post(
            environment.webApiSaguiControlUrl + '/api/template/uploadimagem',
            formData,
            { observe: 'response' }
        );
    }

    getTodasImagens(pagina: number = 1, tamanhoPagina: number = 8): Observable<HttpResponse<any>> {
        return this.http.get(
            `${environment.webApiSaguiControlUrl}/api/template/visualizartodasimagens?pagina=${pagina}&tamanhoPagina=${tamanhoPagina}`,
            { observe: 'response' }
        );
    }

    deleteImagem(nomeArquivo: string): Observable<HttpResponse<any>> {
        return this.http.delete(
            environment.webApiSaguiControlUrl + '/api/template/excluirimagem/' + nomeArquivo,
            { observe: 'response' }
        );
    }
   

    textoAcao(tipoAcao: number): string {

        var textoStatus = "";

        switch (tipoAcao) {
            case 1:
                textoStatus = " Assinar";
                break;
            case 2:
                textoStatus = "Aprovar";
                break;
            case 3:
                textoStatus = "Reconhecer";
                break;
            case 4:
                textoStatus = "Assinar como parte";
                break;
            case 5:
                textoStatus = "Assinar como testemunha";
                break;
            case 6:
                textoStatus = "Assinar como interveniente";
                break;
            case 7:
                textoStatus = "Acusar recebimento";
                break;
            case 8:
                textoStatus = "Assinar como Emissor, Endossante e Avalista";
                break;
            default:
                textoStatus = "";
                break;
        }

        return textoStatus;
    }

    constructor(private http: HttpClient, private sanitizer: DomSanitizer, private saguiClienteService: SaguiClienteService) {

    }
}
